
export default () => {
    document.querySelectorAll(".js-rrp-switcher[data-rrp-switcher-url]").forEach(switcher => {
        switcher.addEventListener("click", event => {
            let checkbox = switcher.querySelector("input[type='checkbox']");

            if (!checkbox) {
                return;
            }

            event.preventDefault();

            fetch(switcher.dataset.rrpSwitcherUrl)
                .then(response => {
                    if (response.ok) {
                        if (checkbox.checked) {
                            checkbox.checked = false;
                            checkbox.removeAttribute("checked");
                        } else {
                            checkbox.checked = true;
                            checkbox.setAttribute("checked", "checked");
                        }

                        checkbox.dispatchEvent(new Event("change"));

                        // reload the current page to update prices
                        window.location.reload();
                    }
                });
        });
    });
};
